module.exports = __webpack_public_path__ + "static/media/review-mangement.15b7fe9a.png";